/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/apps/common/js/aa-wait.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/legacy/utilities/aa-wait.js
**/

function class_aaWait() {
	var self = this;
	self.moduleId = "aaWaitContainer";
	self.waitId = 'aaWaitModule';
	self.fadeInDuration = 2500;
	self.fadeOutDuration = 500;
	
	//Start Wait
	self.start = function () {
		var waitObj = jQuery("#"+self.moduleId);
		if (waitObj.length > 0) {
			jQuery("body > *").css({"display":"none", "visibility":"hidden"});
			jQuery("body").append('<div id="'+self.waitId+'">'+waitObj.html()+'</div>');
			requestAnimationFrame(self.animateBG);
		}
	};
	
	//Stop Wait
	self.stop = function () {
		jQuery("body > #"+self.waitId).remove();
		jQuery("body > *").css({"display":"", "visibility":""});
	};
	
	//Animate Background
	self.animateBG = function() {
		if(jQuery("body").attr("data-bg") == "bg1") {
			jQuery(".bg2").css("z-index", 1);
			jQuery(".bg1,.bg3").css("z-index", -1);
			jQuery(".bg2").fadeTo(self.fadeInDuration, 1, function(){
				jQuery(".bg1").fadeTo(self.fadeOutDuration, 0, function(){
					jQuery("body").attr("data-bg", "bg2");
					requestAnimationFrame(self.animateBG);
				});
			});
			
		} else if(jQuery("body").attr("data-bg") == "bg2") {
			jQuery(".bg3").css("z-index", 1);
			jQuery(".bg1,.bg2").css("z-index", -1);
			jQuery(".bg3").fadeTo(self.fadeInDuration, 1, function(){
				jQuery(".bg2").fadeTo(self.fadeOutDuration, 0, function(){
					jQuery("body").attr("data-bg", "bg3");
					requestAnimationFrame(self.animateBG);
				});
			});
			
		} else if(jQuery("body").attr("data-bg") == "bg3") {
			jQuery(".bg1").css("z-index", 1);
			jQuery(".bg2,.bg3").css("z-index", -1);
			jQuery(".bg1").fadeTo(self.fadeInDuration, 1, function(){
				jQuery(".bg3").fadeTo(self.fadeOutDuration, 0, function(){
					jQuery("body").attr("data-bg", "bg1");
					requestAnimationFrame(self.animateBG);
				});
			});
		}
	};
	
	//Repaint Window before animation
	window.requestAnimationFrame = function(){
	    return (
	        window.requestAnimationFrame       || 
	        window.webkitRequestAnimationFrame || 
	        window.mozRequestAnimationFrame    || 
	        window.oRequestAnimationFrame      || 
	        window.msRequestAnimationFrame     || 
	        function(/* function */ callback){
	            window.setTimeout(callback, (self.fadeInDuration + self.fadeOutDuration));
	        }
	    );
	}();
	
    jQuery(document).ready(function(){
		//	Initialize "wait" background animation
		jQuery("body").attr("data-bg","bg1");
	});	
}

var aaWait = new class_aaWait(); 	// Initialize Wait Class